import { ComponentProps } from 'react';

import { useOpQuery } from 'utils/customHooks/useOpQuery';
import { OpForm } from 'new-components/DLS/OpForm/OpForm';
import { OpFormHiddenItemForDataSetting } from 'new-components/DLS/OpForm/formComponents/OpFormHiddenItemForDataSetting/OpFormHiddenItemForDataSetting';

import { ScopeResource } from './ScopeResource';

import './ScopeResourceSection.scss';

interface ScopeResourceSectionProps {
  orgId: number;
  form?: ComponentProps<typeof OpForm>['form'];
  disabled?: boolean;
}

export const ScopeResourceSection = ({
  orgId,
  form,
  disabled,
}: ScopeResourceSectionProps) => {
  const { data: scopeResourceData } = useOpQuery({
    apiEndpointName: 'listScopeResources',
    parameters: [orgId],
    select: (data) => data.json.data ?? [],
  });

  // Filter out the cobalt scope for now since we currently don't allow
  // users to grant access to it. We can remove this filter once we allow other roles to access Cobalt.
  const filteredScopeResourceData = scopeResourceData?.filter(
    (scopeResource) => scopeResource.name !== 'Assist Chat',
  );

  return (
    <div className="scope-resource-section">
      {filteredScopeResourceData?.map((scopeResource) => (
        <ScopeResource
          key={scopeResource.id}
          disabled={disabled}
          orgId={orgId}
          scopeResource={scopeResource}
          form={form}
        />
      ))}
      <OpFormHiddenItemForDataSetting name="roleScopes" />
    </div>
  );
};
